import { transformDTODate } from "@skylab-shared/core";
import { Transform } from "class-transformer";
import { BankAccountStatus } from "./bank-account-status";

export class BankAccountDTO {
	public default: boolean;
	public bankName: string;
	public number: string;
	public whiteListStatus: BankAccountStatus;
	@Transform(transformDTODate, { toClassOnly: true }) public whiteListLastDateCheck?: Date;
	public whiteListCheckingId: string;
}
